
import Vue from "vue"

export default Vue.extend({
  props: {
    value: { type: Number, required: true },
    pages: { type: Number, required: true },
  },
})
